(function () {
  'use strict';

  if (window.__cartDrawerRecommendationsInit) return;
  window.__cartDrawerRecommendationsInit = true;

  const SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  const SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  const ROOT_SELECTOR = 'cart-drawer-recommendations';
  const SECTION_HANDLE = 'cart-drawer-recommendations';
  const MOUNT_SELECTOR = '[data-cart-yml-mount]';
  const CART_LINES_UPDATE_EVENT = 'shopify:cart:lines-update';
  const LEGACY_CART_UPDATE_EVENT = 'cart:update';
  const MOUNT_RETRY_INTERVAL_MS = 120;
  const MOUNT_RETRY_MAX_ATTEMPTS = 20;

  let swiperAssetsPromise = null;
  const swiperInstances = new WeakMap();
  let refreshTimer = null;
  let emptyCheckTimer = null;
  let refreshInFlight = false;
  let refreshQueued = false;
  let cartItemCountCache = null;
  let mountRetryTimer = null;

  function loadStylesheet(href) {
    if (document.querySelector('link[data-cart-yml-swiper-css]')) return Promise.resolve();

    return new Promise(function (resolve, reject) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.setAttribute('data-cart-yml-swiper-css', '');
      link.onload = resolve;
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    if (window.Swiper) return Promise.resolve(window.Swiper);

    return new Promise(function (resolve, reject) {
      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.setAttribute('data-cart-yml-swiper-js', '');
      script.onload = function () {
        resolve(window.Swiper);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function ensureSwiperAssets() {
    if (!swiperAssetsPromise) {
      swiperAssetsPromise = loadStylesheet(SWIPER_CSS).then(function () {
        return loadScript(SWIPER_JS);
      });
    }
    return swiperAssetsPromise;
  }

  function getCartUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart';
    }
    return '/cart';
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer-component');
  }

  function getCartDrawerDialog() {
    const drawer = getCartDrawer();
    return drawer ? drawer.querySelector('dialog.cart-drawer__dialog') : null;
  }

  function getExistingRoot() {
    return document.getElementById('cart-drawer-recommendations');
  }

  function fetchCartItemCount() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart.js failed');
        return response.json();
      })
      .then(function (cart) {
        cartItemCountCache = cart.item_count || 0;
        return cartItemCountCache;
      })
      .catch(function () {
        return cartItemCountCache;
      });
  }

  function isDrawerMarkedEmpty() {
    const dialog = getCartDrawerDialog();
    return Boolean(dialog && dialog.classList.contains('cart-drawer--empty'));
  }

  function destroySwiper(root) {
    const instance = swiperInstances.get(root);
    if (instance) {
      instance.destroy(true, true);
      swiperInstances.delete(root);
    }
  }

  function initSwiper(root) {
    const swiperEl = root.querySelector('[data-cart-yml-swiper]');
    if (!swiperEl) return Promise.resolve();

    const prevBtn = root.querySelector('[data-cart-yml-prev]');
    const nextBtn = root.querySelector('[data-cart-yml-next]');
    const slideCount = Number(root.dataset.slidesCount || root.querySelectorAll('.swiper-slide').length);

    if (slideCount < 1) return Promise.resolve();

    return ensureSwiperAssets().then(function () {
      destroySwiper(root);

      const swiper = new window.Swiper(swiperEl, {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        speed: 450,
        loop: slideCount > 1,
        allowTouchMove: slideCount > 1,
        watchOverflow: true,
        autoplay: false,
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn
        },
        a11y: {
          enabled: true
        }
      });

      swiperInstances.set(root, swiper);
    });
  }

  function ensureMountTarget() {
    const summary = document.querySelector('cart-drawer-component .cart-drawer__summary');
    if (!summary) return null;

    let mount = summary.querySelector(MOUNT_SELECTOR);
    if (mount) return mount;

    mount = document.createElement('div');
    mount.setAttribute('data-cart-yml-mount', '');
    mount.className = 'cart-drawer__recommendations-mount';

    const summaryContent = summary.querySelector('.cart__summary, cart-summary-component, [data-cart-summary]');
    if (summaryContent) {
      summary.insertBefore(mount, summaryContent);
    } else {
      summary.prepend(mount);
    }

    return mount;
  }

  function parseRecommendationsRoot(html) {
    if (!html || typeof html !== 'string') return null;

    const template = document.createElement('template');
    template.innerHTML = html.trim();

    return (
      template.content.querySelector('#' + ROOT_SELECTOR) ||
      template.content.querySelector(ROOT_SELECTOR)
    );
  }

  function bindRoot(root) {
    if (!root) return;
    root.dataset.bound = 'true';
    initSwiper(root);
  }

  function removeRecommendations() {
    const existing = getExistingRoot();
    if (existing) {
      destroySwiper(existing);
      existing.remove();
    }
  }

  function applyRecommendationsRoot(newRoot) {
    if (!newRoot) return false;

    const existing = getExistingRoot();

    if (existing) {
      destroySwiper(existing);
      existing.replaceWith(newRoot);
      bindRoot(newRoot);
      return true;
    }

    const mount = ensureMountTarget() || document.querySelector(MOUNT_SELECTOR);
    if (!mount) return false;

    mount.innerHTML = '';
    mount.appendChild(newRoot);
    bindRoot(newRoot);
    return true;
  }

  function tryMountFromSections(sections) {
    if (!sections || typeof sections !== 'object') return false;

    const sectionIds = Object.keys(sections);
    for (let i = 0; i < sectionIds.length; i++) {
      const newRoot = parseRecommendationsRoot(sections[sectionIds[i]]);
      if (newRoot && applyRecommendationsRoot(newRoot)) {
        return true;
      }
    }

    return false;
  }

  function scanDrawerRecommendations() {
    const drawer = getCartDrawer();
    if (!drawer) return false;

    scanAndBind(drawer);
    return Boolean(getExistingRoot());
  }

  function mountOrRefreshRecommendations() {
    if (refreshInFlight) {
      refreshQueued = true;
      return Promise.resolve(false);
    }

    refreshInFlight = true;

    return fetchCartItemCount()
      .then(function (itemCount) {
        if (typeof itemCount === 'number' && itemCount < 1) {
          removeRecommendations();
          return false;
        }

        const url = getCartUrl() + '?section_id=' + encodeURIComponent(SECTION_HANDLE);

        return fetch(url, {
          headers: {
            Accept: 'text/html'
          },
          cache: 'no-store'
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Failed to load recommendations');
            return response.text();
          })
          .then(function (html) {
            const newRoot = parseRecommendationsRoot(html);
            const existing = getExistingRoot();

            if (!newRoot) {
              if (existing) bindRoot(existing);
              return Boolean(existing);
            }

            return applyRecommendationsRoot(newRoot);
          });
      })
      .catch(function () {
        const existing = getExistingRoot();
        if (existing) bindRoot(existing);
        return Boolean(existing);
      })
      .finally(function () {
        refreshInFlight = false;

        if (refreshQueued) {
          refreshQueued = false;
          mountOrRefreshRecommendations();
        }
      });
  }

  function clearMountRetry() {
    if (mountRetryTimer) {
      clearTimeout(mountRetryTimer);
      mountRetryTimer = null;
    }
  }

  function mountWithRetry(attempt, sections) {
    attempt = attempt || 0;
    clearMountRetry();

    if (scanDrawerRecommendations()) {
      return Promise.resolve(true);
    }

    if (sections && tryMountFromSections(sections)) {
      return Promise.resolve(true);
    }

    return mountOrRefreshRecommendations().then(function (mounted) {
      if (mounted || getExistingRoot()) {
        return true;
      }

      if (attempt >= MOUNT_RETRY_MAX_ATTEMPTS) {
        return false;
      }

      const itemCount = cartItemCountCache;
      if (typeof itemCount === 'number' && itemCount < 1) {
        return false;
      }

      return new Promise(function (resolve) {
        mountRetryTimer = setTimeout(function () {
          mountWithRetry(attempt + 1, null).then(resolve);
        }, MOUNT_RETRY_INTERVAL_MS);
      });
    });
  }

  function afterCartContentUpdate(sections) {
    clearTimeout(refreshTimer);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        mountWithRetry(0, sections);
      });
    });
  }

  function scheduleRecommendationsRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      afterCartContentUpdate(null);
    }, 0);
  }

  function scheduleEmptyCartCheck() {
    clearTimeout(emptyCheckTimer);
    emptyCheckTimer = setTimeout(function () {
      fetchCartItemCount().then(function (itemCount) {
        if (typeof itemCount === 'number' && itemCount < 1) {
          removeRecommendations();
          return;
        }

        if (!getExistingRoot()) {
          afterCartContentUpdate(null);
        }
      });
    }, 400);
  }

  function setButtonLoading(button, isLoading) {
    const text = button.querySelector('.cart-yml__atc-text');
    const loading = button.querySelector('.cart-yml__atc-loading');

    button.disabled = isLoading;
    if (text) text.hidden = isLoading;
    if (loading) loading.hidden = !isLoading;
  }

  function handleAddToCart(event) {
    const button = event.target.closest('.cart-yml__atc');
    if (!button || button.disabled) return;

    const variantId = button.dataset.variantId;
    if (!variantId) return;

    event.preventDefault();
    setButtonLoading(button, true);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) throw payload;
          return payload;
        });
      })
      .then(function () {
        return publishCartUpdate();
      })
      .then(function () {
        afterCartContentUpdate(null);
      })
      .catch(function () {
        setButtonLoading(button, false);
      });
  }

  async function publishCartUpdate() {
    const cart = await fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      return response.json();
    });

    cartItemCountCache = cart.item_count || 0;

    try {
      const eventsModule = await import('@theme/events');
      const CartUpdateEvent =
        eventsModule.CartUpdateEvent ||
        (eventsModule.default && eventsModule.default.CartUpdateEvent);

      if (CartUpdateEvent) {
        document.dispatchEvent(
          new CartUpdateEvent(cart, 'cart-drawer-recommendations', {
            itemCount: cart.item_count,
            source: 'cart-drawer-recommendations',
            sections: {}
          })
        );
        return cart;
      }
    } catch (error) {
      /* Horizon events module unavailable */
    }

    document.dispatchEvent(
      new CustomEvent(LEGACY_CART_UPDATE_EVENT, {
        bubbles: true,
        detail: {
          data: {
            itemCount: cart.item_count,
            source: 'cart-drawer-recommendations',
            cart: cart
          }
        }
      })
    );

    return cart;
  }

  function onCartLinesUpdate(event) {
    const itemCount =
      event.itemCount ||
      (event.detail && event.detail.itemCount) ||
      (event.detail && event.detail.data && event.detail.data.itemCount);

    if (typeof itemCount === 'number') {
      cartItemCountCache = itemCount;
    }

    const handleResolved = function (result) {
      const sections =
        (result && result.detail && result.detail.sections) ||
        (event.detail && event.detail.sections) ||
        null;

      afterCartContentUpdate(sections);
    };

    if (event.promise && typeof event.promise.then === 'function') {
      event.promise.then(handleResolved).catch(function () {
        afterCartContentUpdate(null);
      });
      return;
    }

    handleResolved(null);
  }

  function onLegacyCartUpdate(event) {
    const source =
      (event.detail && event.detail.data && event.detail.data.source) ||
      (event.detail && event.detail.source) ||
      '';

    const itemCount =
      (event.detail && event.detail.data && event.detail.data.itemCount) ||
      (event.detail && event.detail.itemCount);

    if (typeof itemCount === 'number') {
      cartItemCountCache = itemCount;
    }

    if (source === 'cart-drawer-recommendations') {
      afterCartContentUpdate(null);
      return;
    }

    afterCartContentUpdate(
      (event.detail && event.detail.data && event.detail.data.sections) ||
        (event.detail && event.detail.sections) ||
        null
    );
  }

  function scanAndBind(context) {
    const scope = context && context.querySelectorAll ? context : document;

    if (context && context.matches && context.matches(ROOT_SELECTOR)) {
      bindRoot(context);
    }

    scope.querySelectorAll(ROOT_SELECTOR).forEach(bindRoot);
  }

  function observeDrawerDialog() {
    const dialog = getCartDrawerDialog();
    if (!dialog || dialog.dataset.ymlDialogObserved === 'true') return;

    dialog.dataset.ymlDialogObserved = 'true';

    dialog.addEventListener('toggle', function () {
      if (!dialog.open) return;

      if (getExistingRoot()) {
        bindRoot(getExistingRoot());
        return;
      }

      afterCartContentUpdate(null);
    });

    const dialogObserver = new MutationObserver(function () {
      if (isDrawerMarkedEmpty()) {
        scheduleEmptyCartCheck();
        return;
      }

      if (getExistingRoot()) {
        bindRoot(getExistingRoot());
      }
    });

    dialogObserver.observe(dialog, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function observeCartDrawer() {
    const drawer = getCartDrawer();
    if (!drawer || drawer.dataset.ymlObserved === 'true') return;

    drawer.dataset.ymlObserved = 'true';
    observeDrawerDialog();

    const innerObserver = new MutationObserver(function (mutations) {
      let shouldRefresh = false;
      let recommendationsRemoved = false;

      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          mutation.removedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (
              (node.matches && node.matches(ROOT_SELECTOR)) ||
              (node.querySelector && node.querySelector(ROOT_SELECTOR))
            ) {
              recommendationsRemoved = true;
            }
          });
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (node.matches && node.matches(ROOT_SELECTOR)) {
            bindRoot(node);
            return;
          }

          if (node.querySelector && node.querySelector(ROOT_SELECTOR)) {
            scanAndBind(node);
            return;
          }

          if (
            node.matches &&
            (node.matches('cart-items-component') ||
              node.matches('.cart-drawer__summary') ||
              node.matches(MOUNT_SELECTOR) ||
              node.querySelector('cart-items-component, .cart-drawer__summary, ' + MOUNT_SELECTOR))
          ) {
            shouldRefresh = true;
          }
        });
      });

      if (recommendationsRemoved || shouldRefresh) {
        afterCartContentUpdate(null);
      }
    });

    const inner = drawer.querySelector('.cart-drawer__inner');
    if (inner) {
      innerObserver.observe(inner, {
        childList: true,
        subtree: true
      });
    }
  }

  document.addEventListener('click', handleAddToCart);
  document.addEventListener(CART_LINES_UPDATE_EVENT, onCartLinesUpdate);
  document.addEventListener(LEGACY_CART_UPDATE_EVENT, onLegacyCartUpdate);

  const domObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        scanAndBind(node);

        if (node.matches && node.matches('cart-drawer-component')) {
          observeCartDrawer();
        }

        if (node.querySelector && node.querySelector('cart-drawer-component')) {
          observeCartDrawer();
        }
      });
    });
  });

  function boot() {
    scanAndBind(document);
    observeCartDrawer();

    domObserver.observe(document.body, {
      childList: true,
      subtree: true
    });

    fetchCartItemCount().then(function (itemCount) {
      if (typeof itemCount === 'number' && itemCount > 0) {
        if (!getExistingRoot()) {
          afterCartContentUpdate(null);
        } else {
          bindRoot(getExistingRoot());
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
